<input type="email"
       class="bg-gray"
       [(ngModel)]="control.value"
       #name="ngModel"
       [name]="control.name"
       aria-required="true"
       aria-invalid="false"
       [placeholder]="control.placeholder"
       [value]="control.value"
       [required]="control.required"
       email
       pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
       title="Email cannot contain special characters"
>
<app-field-error [control]="control" [field]="name"></app-field-error>
